export default (state = {}, action) => {
  switch (action.type) {
    case 'INIT': {
      return {
        ...state,
        shopifyLinks: action.links,
      };
    }
    default: {
      return state;
    }
  }
};
